(function () {
  var root = document.querySelector('[data-cart-confirm]');
  if (!root) return;

  var body = root.querySelector('[data-cart-confirm-body]');
  var pageLang = document.documentElement.lang || 'es-ES';
  var labels = pageLang.slice(0, 2).toLowerCase() === 'es'
    ? { dec: 'Restar unidad', inc: 'Sumar unidad' }
    : { dec: 'Decrease quantity', inc: 'Increase quantity' };
  var timer = null;

  function money(cents, currency) {
    return new Intl.NumberFormat(pageLang, { style: 'currency', currency: currency || 'EUR' }).format((Number(cents) || 0) / 100);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function stepper(item) {
    var wrap = el('div', 'cooldo-cart-confirm__qty');
    var dec = el('button', 'cooldo-cart-confirm__qty-btn', '−');
    var inc = el('button', 'cooldo-cart-confirm__qty-btn', '+');
    dec.type = inc.type = 'button';
    dec.setAttribute('aria-label', labels.dec);
    inc.setAttribute('aria-label', labels.inc);
    [[dec, -1], [inc, 1]].forEach(function (pair) {
      pair[0].addEventListener('click', function () {
        dec.disabled = inc.disabled = true;
        change(item.key, item.quantity + pair[1]);
      });
    });
    wrap.appendChild(dec);
    wrap.appendChild(el('span', 'cooldo-cart-confirm__qty-value', item.quantity));
    wrap.appendChild(inc);
    return wrap;
  }

  function render(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      root.hidden = true;
      return;
    }
    var list = el('ul', 'cooldo-cart-confirm__list');
    cart.items.forEach(function (item) {
      var li = el('li', 'cooldo-cart-confirm__item');
      var img = el('img', 'cooldo-cart-confirm__img');
      if (item.image) img.src = item.image;
      img.alt = item.title || '';
      img.loading = 'lazy';
      var info = el('div', 'cooldo-cart-confirm__info');
      info.appendChild(el('p', 'cooldo-cart-confirm__name', item.title || ''));
      info.appendChild(stepper(item));
      li.appendChild(img);
      li.appendChild(info);
      li.appendChild(el('span', 'cooldo-cart-confirm__price', money(item.final_line_price, cart.currency)));
      list.appendChild(li);
    });
    body.replaceChildren(list);
    root.hidden = false;
  }

  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(render)
      .catch(function () {});
  }

  function change(key, quantity) {
    var url = ((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart change failed');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { noOpen: true } }));
      })
      .catch(load);
  }

  // El cajon y las fichas disparan estos eventos al cambiar el carrito; se agrupan en una sola lectura.
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(load, 120);
  }

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('iurop:cart-rendered', schedule);
  window.addEventListener('pageshow', schedule);
  load();
})();
